import React, { useCallback } from 'react';
import { createUseStyles } from 'react-jss';
import { ReactComponent as IconClose } from 'assets/image/btn-close.svg';

import * as Modal from 'app/components/common/modal/Modal';

import { useDispatcher, useSelector } from 'app/store/utils/redux/hooks';
import { IPageGift } from 'app/store/nodes/card/interfaces';
import { guard } from 'app/utils';

interface IGiftTerms {
  onClose?: () => void
}

const GiftTerms: React.FC<IGiftTerms> = (props) => {
  const { onClose } = props;
  const classes = useStyles();
  const page = useSelector((state) => {
    const result = state.card.pages[state.flipbook.currentPage];
    return guard.isVirtualGiftPage(result) ? result : null;
  });

  const terms = page?.items?.gift?.terms;
  const html = terms?.replace(/[\n]/g, '<br />') || '';

  return (
    <div className={classes.componentGift}>
      <div className={classes.body}>
        <div className={classes.terms} dangerouslySetInnerHTML={{ __html: html }} />
      </div>
      <div className={classes.close} onClick={onClose}><IconClose /></div>
    </div>
  );
};

const ProxyGiftTerms: React.FC<IGiftTerms> = (props) => {
  const isOpen = useSelector((state) => state.gift.isOpenTerms);
  const page = useSelector((state) => state?.card?.pages[state?.flipbook?.currentPage] as IPageGift);

  const actions = useDispatcher();

  const handleClose = useCallback(() => {
    actions.gift.setOpenGiftTerms(false);
  }, [actions]);

  if (page?.type !== 'PageGift') {
    return null;
  }

  return (
    <Modal.Item
      visible={isOpen}
      hAlign="center"
      vAlign="flex-start"
      onOutsideClick={handleClose}
    >
      <GiftTerms {...props} onClose={handleClose} />
    </Modal.Item>
  );
};

const useStyles = createUseStyles({
  componentGift: {
    position: 'relative',
    marginTop: '9.4rem',
    borderRadius: '2.5rem',
    maxWidth: '30rem',
    background: 'white',
    boxShadow: '0 0 5.2rem rgba(0,0,0,.35)',
  },
  body: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    padding: '3.5rem 3.7rem',
    pointerEvents: 'all',
  },
  close: {
    position: 'absolute',
    right: '1rem',
    top: '1rem',
    border: 0,
    padding: 0,
    width: '4rem',
    height: '4rem',
    background: 'transparent',
    cursor: 'pointer',
    outline: 'none',
  },
  terms: {
    '&': {
      fontSize: '1.2rem',
      maxHeight: '40rem',
      overflow: 'auto',
    },
    '& > p': {
      marginTop: 0,
    },
  },
});

export default ProxyGiftTerms;
